import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { notification } from 'antd';
import rest from 'util/Api';
import * as Yup from 'yup';
import { authProfile } from 'redux/auth/selectors';
import { actions } from 'redux/store/slice';
import { PHONE_REGEX } from 'constants/defaultValues';
import { OTHER_NOTIFIER_OPTION } from 'constants/options';
import API from 'constants/api';
import Store from '../store';

const defaultValues = {
  detail: '',
  address: '',
  contactName: '',
  email: '',
  geoKey: '',
  name: '',
  phone: '',
  id: '',
  username: '',
  hasIntegration: false,
  notifierType: null,
  active: true,
  password: '',
  confirmpassword: '',
  lat: null,
  lng: null,
  resolvedStreet: '',
  resolvedNumber: '',
  resolvedLocality: '',
  resolvedZipCode: '',
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Especifique el nombre de la tienda'),
  phone: Yup.string()
    .matches(PHONE_REGEX, 'Formato de telefono invalido.')
    .typeError('Especifique el teléfono de la tienda')
    .required('Especifique el teléfono de la tienda'),
  username: Yup.string().when('hasIntegration', {
    is: true,
    then: Yup.string().required(
      'Indique el nombre de usuario de la integración',
    ),
    otherwise: Yup.string().nullable(),
  }),
  notifierType: Yup.number().when('hasIntegration', {
    is: true,
    then: Yup.number()
      .typeError('Indique el tipo de integración')
      .required('Indique el tipo de integración'),
    otherwise: Yup.number().nullable(),
  }),
  password: Yup.string().when('hasIntegration', {
    is: true,
    then: Yup.string().required('Especifique la contraseña de la integración'),
    otherwise: Yup.string().nullable(),
  }),
  confirmpassword: Yup.string().when('hasIntegration', {
    is: true,
    then: Yup.string().test(
      'password-match',
      'Las contraseñas deben coincidir',
      function callback(value) {
        return this.parent.password === value;
      },
    ),
    otherwise: Yup.string().nullable(),
  }),
  lat: Yup.number().nullable(),
  lng: Yup.number().nullable(),
  resolvedStreet: Yup.string().nullable(),
  resolvedNumber: Yup.string().nullable(),
  resolvedLocality: Yup.string().nullable(),
  resolvedZipCode: Yup.string().nullable(),
});

const AddStore = () => {
  const profile = useSelector(authProfile);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleSubmit = async (values) => {
    dispatch(actions.loading());
    let credentials;
    if (values.hasIntegration) {
      const { username, password, notifierType } = values;
      credentials = {
        username,
        password,
        notifier:
          notifierType !== OTHER_NOTIFIER_OPTION.value ? notifierType : null,
      };
    }
    const payload = {
      name: values.name,
      detail: values.detail,
      address: values.address
        ? values.address
        : profile.marketplace.dispatchAddress,
      phone: values.phone,
      contactName: values.contactName,
      email: values.email,
      storeCode: values.id,
      active: values.active,
      geoKey: values.geokey,
      ownerId: profile.marketplace.id,
      ownerType: profile.ownerType,
      credentials,
      lat: values.lat,
      lng: values.lng,
      resolvedStreet: values.resolvedStreet,
      resolvedNumber: values.resolvedNumber,
      resolvedLocality: values.resolvedLocality,
      resolvedZipCode: values.resolvedZipCode,
    };
    try {
      const response = await rest.post(API.stores.create, payload);
      if (rest.isSuccessResponse(response)) {
        notification.success({
          message: 'Creación de Tienda',
          description: `La Tienda ${values.name} ha sido creada correctamente.`,
        });
        if (response?.data?.data?.credentials) {
          notification.success({
            message: 'Credenciales Generadas',
            description:
              'Se han generado correctamente las credenciales de integración',
          });
        }
        setTimeout(() => {
          history.push('/stores');
        }, 1000);
      }
    } catch (error) {
      notification.error({
        message: 'Error al crear la tienda',
        description:
          error?.response?.data?.message ||
          'Ha ocurrido un error, intente nuevamente',
      });
    } finally {
      dispatch(actions.loaded());
    }
  };
  return (
    <Store
      initialValues={defaultValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    />
  );
};

export default AddStore;
